import React, { useEffect, useRef } from "react";

export default function SocialLogos() {
  const logos = [
    { src: "/facebook.png", link: "https://www.facebook.com/rccsonline", alt: "Facebook" },
    { src: "/instagram.png", link: "https://www.instagram.com/rccsonline/", alt: "Instagram" },
    { src: "/youtube.png", link: "https://www.youtube.com/c/RoyalCollegeComputerSociety", alt: "YouTube" },
    { src: "/twitter.png", link: "https://twitter.com/rccsonline", alt: "Twitter" },
    { src: "/linkedin.png", link: "https://www.linkedin.com/company/rccsonline/", alt: "LinkedIn" },
  ];

  const containerRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!containerRef.current) return;
      const links = containerRef.current.querySelectorAll("a");
      if (links.length === 0) return;

      const randomLink = links[Math.floor(Math.random() * links.length)];
      randomLink.classList.add("flicker");

      setTimeout(() => {
        randomLink.classList.remove("flicker");
      }, 1500); // match animation duration
    }, 1000 + Math.random() * 2000); // random every 3-8s

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="logo-container" ref={containerRef}>
      {logos.map((logo, idx) => (
        <a key={idx} href={logo.link} target="_blank" rel="noopener noreferrer">
          <img className="logo" src={logo.src} alt={logo.alt} width={26} height={26} />
        </a>
      ))}
    </div>
  );
}
